import { create } from "zustand";
import { defaultProgramData } from "../pages/protected/workflows/CreateCampaign/flow/flowSettings";

const campaignStore = (set) => ({
  programData: defaultProgramData,
  setProgramData: (newData) => set({ programData: newData }),
  timeStart: defaultProgramData.time_start_sending,
  setTimeStart: (newData) => set({ timeStart: newData }),
  timeStop: defaultProgramData.time_stop_sending,
  setTimeStop: (newData) => set({ timeStop: newData }),
  oldProgramData: null,
  setOldProgramData: (newData) => set({ oldProgramData: newData }),
  filterType: [],
  setFilterType: (newData) => set({ filterType: newData }),
  workflowType: [],
  setWorkflowType: (newData) => set({ workflowType: newData }),
  agentId: null,
  setAgentId: (newData) => set({ agentId: newData }),
});

export const useCampaignStore = create(campaignStore);
